var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var printableCollection = require('./printableCollection');

/**
 * Data Behavior hooked up to the printable cache.
 * @class PrintableDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: printableCollection
});
